// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"159c4c9c","455":"db92fa9a","977":"b5fb48d9"}[chunkId] + ".chunk.js";
};